<template>
    <div class="page-table scrollable only-y mainDiv">
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.urun.liste.baslikYayin")}}</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp"
             style="background: #fff !important;">
            <el-col class="margin-bottom-10" :lg="20" :md="20" :sm="24" :xs="24">
                <el-row>
                    <el-col :lg="6" :md="6" :sm="24" :xs="24">
                        <el-radio-group size="small" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                        text-color="gray">
                            <el-radio-button label="1">
                                <i class="mdi mdi-cards-outline mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                                <transition
                                        name="slide-fade"><label v-if="selectIcon==='1'">Yayındaki Ürünler</label>
                                </transition>
                            </el-radio-button>
                            <el-radio-button label="0">
                                <i class="mdi mdi-cards-outline mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                                <transition
                                        name="slide-fade"><label v-if="selectIcon==='0'">Taslak Ürünler</label>
                                </transition>
                            </el-radio-button>
                        </el-radio-group>
                    </el-col>


                    <el-col :lg="6" :md="6" :sm="24" :xs="24" class="mb-10">
                        <el-select style="width: 100%"
                                   v-on:change="getkategoriUrunList"
                                   placeholder="Kategori Seçiniz"
                                   clearable
                                   filterable
                                   v-model="secilenKategori">
                            <el-option
                                    v-for="item in urunKategoriListesi"
                                    :key="item.ukategoriId"
                                    :label="item.baslik"
                                    :value="item.ukategoriId">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </el-col>
            <el-col class="margin-bottom-10" :lg="4" :md="4" :sm="24" :xs="24">
                <el-button
                        v-on:click="routeUrun('Ürün Tanımla')"
                        style="float: right"
                        size="mini"
                        icon="el-icon-plus">
                </el-button>
            </el-col>
            <!--<el-col class="margin-bottom-10" :lg="4" :md="4" :sm="24" :xs="24">-->
                <!--<el-radio-group style="float: right" size="mini" v-on:change="handleChangeListe($event)" v-model="radioListe" fill="#E5F5F9"-->
                                <!--text-color="gray">-->
                    <!--<el-radio-button label="1">-->
                        <!--<i class="mdi mdi-format-list-bulleted mdi-18px"></i>-->
                        <!--<transition-->
                                <!--name="slide-fade"><label v-if="selectIconListe==='1'"></label>-->
                        <!--</transition>-->
                    <!--</el-radio-button>-->
                    <!--<el-radio-button label="2">-->
                        <!--<i class="mdi mdi-image-size-select-actual mdi-18px"></i>-->
                        <!--<transition-->
                                <!--name="slide-fade"><label v-if="selectIconListe==='2'"></label>-->
                        <!--</transition>-->
                    <!--</el-radio-button>-->
                <!--</el-radio-group>-->
            <!--</el-col>-->
            <div v-if="listeTipi === '1'">
                <el-table
                        border
                        stripe
                        :data="urunlerList"
                        style="width: 100%">
                    <el-table-column
                            label="Sıra"
                            type="index">
                    </el-table-column>
                    <el-table-column
                            prop="urunKodu"
                            label="Ürün Kodu"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            label="Resim"
                            width="80">
                        <template slot-scope="scope">
                            <el-popover
                                    transition="el-fade-in-linear"
                                    placement="left"
                                    width="auto"
                                    trigger="hover">
                                <img v-if="scope.row.resim" :src="imagepath+scope.row.resim"
                                     :alt="scope.row.baslik">
                                <i style="font-size: 24px; cursor: pointer; color: #337ab7" slot="reference"
                                   class="el-icon-picture"></i>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column
                            sortable
                            prop="fiyatDetay"
                            label="Fiyat"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            sortable
                            show-overflow-tooltip
                            prop="baslik"
                            label="Başlık"
                            width="auto">
                    </el-table-column>

                    <el-table-column
                            label="Online Satış"
                            width="110"
                            align="center">
                            <template slot-scope="scope">
                                <el-button
                                        type="text"
                                        :icon="scope.row.onlineSatis=== '1' ? 'mdi mdi-star mdi-24px' : 'mdi mdi-star-outline mdi-24px'"
                                        @click="onlineSatisGuncelle(scope.row.urunId)">
                            </el-button>
                            
                            </template>
                    </el-table-column>
                    <el-table-column
                            label="Vitrin"
                            width="100"
                            align="center">
                            <template slot-scope="scope">
                                <el-button
                                        v-if="VitrinListeKontrol(scope.row.urunId)"
                                        type="text"
                                        icon="mdi mdi-star mdi-24px"
                                        @click="VitrinGuncelle(scope.row.urunId, 0),VitrinListeKontrol(scope.row.urunId)">
                            </el-button>
                            <!--  -->
                            <el-button 
                                    v-if="!VitrinListeKontrol(scope.row.urunId)"
                                    type="text"
                                    icon="mdi mdi-star-outline mdi-24px"
                                    @click="VitrinGuncelle(scope.row.urunId, 1),  VitrinListeKontrol(scope.row.urunId)">
                            </el-button>
                            </template>
                    </el-table-column>


                    <el-table-column
                            label="Kampanya"
                            width="150"
                            align="center">
                            <template slot-scope="scope">
                                <el-button
                                        v-if="KampanyaListeKontrol(scope.row.urunId)"
                                        type="text"
                                        icon="mdi mdi-star mdi-24px"
                                        @click="kampanyaGuncelle(scope.row.urunId)">
                            </el-button>
                            <!-- kampanyaListe kontole gider, eger true donerse içi dolu yıldız false ise içi boş yıldız -->
                            <el-button 
                                    v-if="!KampanyaListeKontrol(scope.row.urunId)"
                                    type="text"
                                    icon="mdi mdi-star-outline mdi-24px"
                                    @click="kampanyaEkle(scope.row.urunId)">
                            </el-button>
                            </template>
                    </el-table-column>
                    <el-table-column
                            label="İşlem"
                            align="right"
                            width="250">
                        <template slot="header" slot-scope="scope">
                            <el-input :disabled="secilenKategori !== ''" clearable v-on:clear="clearable" v-model="search" v-on:input="searchMethod"
                                      placeholder="Ara" size="mini"></el-input>
                        </template>
                        <template slot-scope="scope">
                            <el-tooltip :content='scope.row.olusturan+" / "+scope.row.olusumTarihi' :open-delay="500"
                                        placement="bottom">
                                <el-button
                                        type="text"
                                        icon="mdi mdi-account mdi-24px"
                                        >
                                </el-button>
                            </el-tooltip>
                            <!--<el-tooltip :content='$t("src.views.apps.urun.liste.urunbaglanti")'-->
                                        <!--:open-delay="500"-->
                                        <!--placement="bottom">-->
                                <!--<el-button-->
                                        <!--class="margin-top-7 margin-left-5"-->
                                        <!--v-on:click="urunDetay(scope.row)"-->
                                        <!--type="text"-->
                                        <!--icon="mdi mdi-camera mdi-24px">-->
                                <!--</el-button>-->
                            <!--</el-tooltip>-->
                            <el-tooltip :content='$t("src.views.apps.urun.liste.urunduzenle")'
                                        :open-delay="500"
                                        placement="bottom">
                                <el-button
                                        v-if="root || yetkiList.urunGuncelle"
                                        v-on:click="routeUrun('Ürün Düzenle',scope.row)"
                                        type="text"
                                        class="buttonEdit margin-right-5"
                                        icon="el-icon-edit">
                                </el-button>
                            </el-tooltip>
                            <el-tooltip :content='$t("src.views.apps.urun.liste.onizleme")' :open-delay="500"
                                        placement="bottom">
                                <el-link target="_blank" class="margin-bottom-7 buttonDetay" icon="mdi mdi-redo-variant mdi-24px"
                                         :underline="false" :href="path+'de/'+scope.row.link">
                                </el-link>
                            </el-tooltip>
                            <el-tooltip :content='$t("src.views.apps.urun.liste.urunkaldir")' :open-delay="500"
                                        placement="bottom">
                                <el-button
                                        v-if="selectIcon==='1' && (root || yetkiList.urunDurumChange)"
                                        @click="deleteDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                        size="mini"
                                        class="buttonDel"
                                        type="text"
                                        icon="mdi mdi-pause mdi-24px">
                                </el-button>
                            </el-tooltip>
                            <el-tooltip :content='$t("src.views.apps.sayfa.liste.yayindanKaldir")' :open-delay="500"
                                        placement="bottom">
                                <el-button
                                        v-if="selectIcon==='0' && (root || yetkiList.urunDurumChange)"
                                        @click="urunDurumDegis(scope.row,scope.$index,urunlerList,'1')"
                                        type="text"
                                        icon="mdi mdi-play mdi-24px">
                                </el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--<div class="main box grow flex" v-if="listeTipi === '2'">-->
                <!--<div class="page-ecommerce-products flex" style="width: 100%">-->
                    <!--<div :class="{'sidebar':true, 'open':sidebarOpen}">-->
                        <!--<vue-scroll class="scroller">-->
                            <!--<div class="widget">-->
                                <!--<div class="title">Kategori</div>-->
                                <!--<div class="content">-->
                                    <!--<el-tree-->
                                            <!--class="baskaTree"-->
                                            <!--:data="kategoriListesi"-->
                                            <!--@check="handleNodeClick"-->
                                            <!--node-key="id"-->
                                            <!--icon-class-->
                                            <!--show-checkbox-->
                                            <!--:props="treeProps">-->
                                    <!--</el-tree>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="widget">-->
                                <!--<div class="title">Fiyat</div>-->
                                <!--<div class="content">-->
                                    <!--<el-slider-->
                                            <!--v-on:change="fiyatSliderChange"-->
                                            <!--v-model="range"-->
                                            <!--range-->
                                            <!--:max="500"-->
                                            <!--class="themed"-->
                                    <!--&gt;</el-slider>-->
                                    <!--<div class="flex justify-space-between o-060">-->
                                        <!--<span> {{range[0]}} CHF</span>-->
                                        <!--<span> {{range[1]}} CHF</span>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</vue-scroll>-->
                    <!--</div>-->
                    <!--<div class="list-container box grow flex column">-->
                        <!--<div class="list scrollable only-y box grow">-->
                            <!--<div id="flip-list-demo" class="demo">-->
                                <!--<transition-group name="flip-list">-->
                                    <!--<div v-for="i in urunlerList" :key="i.urunId" class="item">-->
                                        <!--<div class="wrapper card-shadow&#45;&#45;medium">-->
                                            <!--<div class="image p-20" style="background: #eeeeee">-->
                                                <!--<el-carousel :autoplay="false" trigger="click" height="150px">-->
                                                    <!--<el-carousel-item v-for="item in i.resim" :key="item">-->
                                                        <!--<div class="bg" :style="'background-image: url('+imagepath+item+')'"></div>-->
                                                    <!--</el-carousel-item>-->
                                                <!--</el-carousel>-->
                                            <!--</div>-->
                                            <!--<div class="detail p-20">-->
                                                <!--<div class="name mt-20">-->
                                                    <!--{{i.baslik}}-->
                                                <!--</div>-->
                                                <!--<div class="price">-->
                                                    <!--{{i.fiyat}} CHF-->
                                                <!--</div>-->
                                                <!--<div class="buttons flex justify-space-between">-->
                                                    <!--<div>-->
                                                        <!--<button v-on:click="urundata = i; dialogVisibleUrunFotograf = true">-->
                                                            <!--<i class="mdi mdi-camera"></i></button>-->
                                                        <!--<button v-on:click="urundata = i; dialogVisibleUrunBaglanti = true"-->
                                                                <!--class="ml-5"><i class="el-icon-paperclip"></i></button>-->
                                                        <!--<button class="ml-5"-->
                                                                <!--v-if="root || yetkiList.urunGuncelle"-->
                                                                <!--v-on:click="routeUrun('Ürün Düzenle',i)">-->
                                                            <!--<i class="el-icon-edit"></i>-->
                                                        <!--</button>-->
                                                    <!--</div>-->
                                                <!--</div>-->
                                            <!--</div>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</transition-group>-->
                            <!--</div>-->

                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
            <el-pagination
                    v-if="!secilenKategori"
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
            </el-pagination>
        </div>
        <el-dialog
                :title='$t("src.views.apps.urun.liste.uyari")'
                :visible.sync="deleteDialogVisible"
                width="30%"
                center>
            <span>'{{selection.baslik}}' {{$t('src.views.apps.urun.liste.uruntaslak')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="urunDurumDegis(selection,selectionIndex,urunlerList,'0'), deleteDialogVisible = false"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-close"
                               @click="deleteDialogVisible = false"></el-button>
                </span>
        </el-dialog>
        <!--<urun-baglanti v-if="dialogVisibleUrunBaglanti" :dialogvisible.sync="dialogVisibleUrunBaglanti"-->
        <!--:urundata="urundata"></urun-baglanti>-->
        <urun-fotograf v-if="dialogVisibleUrunFotograf" :dialogvisible.sync="dialogVisibleUrunFotograf"
                       :urundata="urundata"></urun-fotograf>
    </div>
</template>

<script>
    import urunService from '../../../WSProvider/UrunService'
    import kampanyaService from '../../../WSProvider/KampanyaService'
    import vitrinService from "../../../WSProvider/VitrinService"
    // import UrunBaglanti from '@/components/UrunBaglanti'
    import UrunFotograf from '@/components/UrunFotograf'
    import notification from '../../../notification'
    import EventBus from '@/components/event-bus'
    let base64 = require('base64_js');
    let userDataKader = "";

    export default {
        name: "UrunListesi",
        components: {
            // UrunBaglanti,
            UrunFotograf
        },
        data() {
            return {
                items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                sidebarOpen: false,
                filtersSorumlu: [],
                kategoriListesi: [],
                kampanyaListesi: [],
                vitrinListesi: [],
                secilenKategoriList: [],
                treeProps: {
                    children: 'children',
                    label: 'name',
                    id: 'id'
                },
                range: [0, 100],
                passiveColor: '#9a9a9a',
                activeColor: '#f7ba2a',
                activeColorHediye: '#ed1d24',
                dialogVisibleUrunBaglanti: false,
                dialogVisibleUrunFotograf: false,
                urundata: {},
                path: urunService.path,
                imagepath: urunService.imageUrlOrta,
                sizes: 10,
                page: 0,
                postPage: 0,
                total: null,
                urunlerList: [],
                deleteDialogVisible: false,
                selection: '',
                selectIcon: '1',
                listeTipi: '1',
                selectIconListe: '1',
                radio: '1',
                search: '',
                radioListe: '2',
                selectionIndex: '',
                secilenKategori: '',
                urunKategoriListesi: [],
                root: false,
                yetkiList: {
                    urunGuncelle: false,
                    urunDurumChange: false,
                },
            }
        },
        mounted() {
            let self = this;
            if (localStorage.getItem("userDataKader")) {
                userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
                if (userDataKader["tur"]) {
                    if (userDataKader["tur"] === '1' || userDataKader["tur"] === '2') {
                        self.root = true;
                        self.yetkiList.urunDurumChange = true;
                        self.yetkiList.urunGuncelle = true;
                    }
                }
                if (userDataKader["yetki"]) {
                    userDataKader["yetki"].forEach(function (value) {
                        switch (value.yetkiKodu) {
                            case 'YK-482800':
                                self.yetkiList.urunGuncelle = true;
                                self.yetkiList.urunDurumChange = true;
                                break;
                            case 'YK-462516':
                                self.yetkiList.urunDurumChange = true;
                                break;
                        }
                    });
                }

            }
            EventBus.$on('urunList', function (bool) {
                if (bool) {
                    this.secilenKategori = "";
                    self.urunCount();
                    self.getUrunList();
                    self.getKategoriListesi();
                    self.getUrunKategoriListesi();
                }
            });
            this.urunCount();
            this.getUrunList();
            this.getKategoriListesi();
            this.getUrunKategoriListesi();
            this.getKampanyaList();
            this.getVitrinList();
        },
        methods: {
            getVitrinList(islemTuru="anasayfa"){
                vitrinService.VitrinOku(islemTuru).then(response => {
                    if(response.status === 200){
                        this.vitrinListesi = response.data
                    }else{
                        notification.Status(response.status, this)
                    }
                })
            },
            VitrinGuncelle( urunId, deger, islemTuru="anasayfa"){
                vitrinService.VitrinGuncelle(islemTuru, urunId, deger).then(response => {
                    if(response.status){
                        this.getVitrinList();
                        this.VitrinListeKontrol(urunId)
                    }
                })
            },
            VitrinListeKontrol(urunId){
                let control = this.vitrinListesi.find(e => e.urunId === urunId)
                if(control){
                    return true // kampanya listesinde varsa true doner
                }
                return false;
            },

            onlineSatisGuncelle(urunID){
                urunService.urunOnlineSatisDurumGuncelle(urunID).then(response => {
                    if(response.status === 200){
                        this.getUrunList();
                        this.secilenKategori = "";
                        notification.Status("success", this, "Ürün Başarıyla Online Satışa Açıldı.")
                    }
                    else{
                        notification.Status(response.status, this)
                    }
                })
                // console.log("online urun satis : ",urunID)
            },

            getKampanyaList(){
                kampanyaService.kampanyaList().then(response => {
                    if(response.status === 200){
                            this.kampanyaListesi = response.data;
                    }
                    else{
                        notification.Status(response.status, this)
                    }
                })
            },
            kampanyaEkle(urunId){
                if(this.KampanyaListeKontrol(urunId) === false){
                    kampanyaService.kampanyaTanimla(urunId).then(response => {
                        if(response.status === 200 ){
                            this.getKampanyaList() // kampanya listesini guncellemek için
                            this.KampanyaListeKontrol(urunId)
                        }
                    })
                }
                
            },
            kampanyaGuncelle(urunId){
                if(this.KampanyaListeKontrol(urunId) === true){
                    kampanyaService.kampanyaGuncelle(urunId, 0).then(response => {
                        if(response.status === 200){
                            this.getKampanyaList() // kampanya listesini guncellemek için
                            this.KampanyaListeKontrol(urunId)
                        }
                    })
                }
            },
            KampanyaListeKontrol(urunId){
                let control = this.kampanyaListesi.find(e => e.urunId === urunId)
                if(control){
                    return true // kampanya listesinde varsa true doner
                }
                return false;
            },


            searchMethod(val) {
                if (val !== '') {
                    var dizi = [];
                    urunService.urunListesiArama(this.selectIcon,val).then((response) => {
                        if (response.status === 200) {
                            response.data.forEach(function (e) {
                                dizi.push(e);
                            });
                            this.urunlerList = dizi;
                        } else notification.Status(response.status, this)
                    })
                } else this.clearable();
            },
            clearable() {
                this.urunlerList = [];
                this.getUrunList();
                this.urunCount();
            },
            handleSizeChange(val) {
                this.sizes = val;
                this.getUrunList();
            },
            handleChange(event) {
                this.selectIcon = event;
                this.getUrunList();
            },
            handleChangeListe(event) {
                this.listeTipi = event;
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getUrunList();
            },
            handleNodeClick(data, checked, indeterminate) {
                let self = this;
                this.secilenKategoriList = [];
                Object.values(checked.checkedNodes).forEach(function (e) {
                    self.secilenKategoriList.push(e.id);
                });
                Object.values(checked.halfCheckedNodes).forEach(function (e) {
                    self.secilenKategoriList.push(e.id);
                });
                urunService.urunFiyatArama("", "", this.secilenKategoriList).then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            if (e.fiyat) {
                                e.fiyatDetay = e.fiyat + " CHF";
                            }
                        });
                        self.urunlerList = response.data;
                    }
                });
            },
            fiyatSliderChange(val) {
                let self = this;
                urunService.urunFiyatArama(val[0], val[1], this.secilenKategoriList).then((response) => {
                    if (response.status === 200) {
                        self.urunlerList = response.data;
                    }
                });
            },
            urunCount() {
                urunService.urunCount(this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        this.total = parseInt(response.data);
                    }
                });
            },
            urunDetay(scope) {
                urunService.urunDetay(scope.urunId).then((response) => {
                    if (response.status === 200) {
                        this.urundata = response.data;
                        this.dialogVisibleUrunFotograf = true
                    }
                });

            },
            getKategoriListesi() {
                let self = this;
                urunService.kategoriTree().then((response) => {
                    if (response.status === 200) {
                        self.kategoriListesi = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            getUrunKategoriListesi() {
                let self = this;
                urunService.ukategoriList('1').then((response) => {
                    if (response.status === 200) {
                        self.urunKategoriListesi = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            filterTagS(value, row) {
                return row.kategori[0].ukategoriKodu === value;
            },
            routeUrun(name, scope) {
                var tabList = this.$store.getters.getTabList;
                if (scope) {
                    this.$store.commit('changeUpdateLink', scope.link);
                    this.$store.commit('changeUpdateKodu', scope.urunId);
                }
                var header = linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            },
            getUrunList() {
                let self = this;
                urunService.urunListesi(this.selectIcon, this.postPage, this.sizes).then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            if (e.fiyat) {
                                e.fiyatDetay = e.fiyat + " CHF";
                            }
                        });
                        this.urunlerList = response.data;
                        // console.log(this.urunlerList)
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            getkategoriUrunList(val) {
                if (val) {
                    urunService.kategoriUrunList(val,'de').then((response) => {
                        if (response.status === 200) {
                            response.data.forEach(function (e) {
                                if (e.fiyat) {
                                    e.fiyatDetay = e.fiyat + " CHF";
                                }
                            });
                            this.urunlerList = response.data;
                        } else {
                            notification.Status(response.status, this)
                        }
                    });
                } else {
                    this.getUrunList()
                }
            },
            urunDurumDegis(selection, index, list, durum) {
                urunService.urunDurumGuncelle(selection.urunId, durum).then((response) => {
                    if (response.status === 200) {
                        switch (durum) {
                            case '0':
                                list.splice(index, 1);
                                notification.Status("success", this, "Ürün taslağa taşındı.");
                                break;
                            case '1':
                                list.splice(index, 1);
                                notification.Status("success", this, "Ürün yayına alındı.");
                                break;
                        }
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
</script>

<style lang="scss">
    .star-button{
        background-color: rgb(148, 198, 255);
    }

    .el-table .info-row {
        background: rgba(125, 199, 225, 0.45);
    }

    .el-table .error-row {
        background: rgba(249, 0, 26, 0.08);
    }

    .el-table .success-row {
        background: rgba(3, 249, 0, 0.08);
    }

    .el-table .warning-row {
        background: rgba(245, 249, 0, 0.08);
    }
</style>
<style lang="scss" scoped>
    .refresh {
        color: #fff;
        float: right;
        padding: 0 !important;
        transition: all 0.5s;

    }

    .refresh:hover {
        transform: rotate(360deg);
    }

    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .el-radio-button--mini .el-radio-button__inner label {
        position: relative;
        bottom: 5px;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }

</style>
<style lang="scss">
    .slide-fade-enter-active {
        transition: all .3s ease;
    }


    @media (min-width: 768px) {
        .el-radio-button--mini .el-radio-button__inner {
            padding: 0 10px !important;
            font-size: 11px;
            border-radius: 0;
        }
    }


    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>
<style lang="scss" scoped>
    @import '../../../assets/scss/_variables';

    .page-ecommerce-products {
        .sidebar {
            width: 300px;
            margin-right: 20px;
            margin-right: 10px;
            margin-left: -10px;

            .scroller {
                padding: 10px;
                padding-top: 0px;
                width: 100%;
                height: 100%;
                box-sizing: border-box;
            }

            .widget {
                background: white;
                border-radius: 4px;
                margin-bottom: 20px;
                box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.07), 0 3px 6px 0 rgba(0, 0, 0, 0.065);
                overflow: hidden;

                &.close-filter-box {
                    display: none;
                    text-align: center;

                    button {
                        width: 100%;
                        border: none;
                        text-transform: uppercase;
                        outline: none;
                        font-family: inherit;
                        font-weight: bold;
                        padding: 5px 0px;
                        border-bottom: 2px solid;
                        background: white;
                        color: #ec205f;
                        cursor: pointer;
                    }
                }

                &.select-color {
                    ul, li {
                        padding: 0;
                        list-style: none;
                        margin: 0;
                    }

                    li {
                        margin-bottom: 10px;
                    }

                    .color-box {
                        background: transparent;
                        width: 12px;
                        height: 12px;
                        display: inline-block;
                        margin-right: 10px;
                    }
                }

                .title {
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                    padding: 15px 20px;
                }

                .content {
                    padding: 15px 20px;
                }
            }
        }

        .toggle-filter-box {
            padding: 10px;
            padding-top: 0px;
            text-align: right;
            display: none;

            button {
                border: none;
                text-transform: uppercase;
                outline: none;
                font-family: inherit;
                font-weight: bold;
                padding: 1px 2px;
                border-bottom: 2px solid;
                color: #13ce66;
                background: transparent;
                cursor: pointer;
            }
        }

        .list {
            .item {
                display: block;
                width: 25%;
                height: 400px;
                padding: 0 10px;
                padding-bottom: 20px;
                box-sizing: border-box;
                float: left;

                .wrapper {
                    box-sizing: border-box;
                    height: 100%;
                    position: relative;
                    cursor: pointer;
                    transition: all .25s;

                    .image {
                        box-sizing: border-box;
                        height: 150px;
                        width: 100%;
                        background-color: white;
                        padding-bottom: 10px;

                        .bg {
                            background-color: white;
                            background-size: contain;
                            background-repeat: no-repeat;
                            background-position: center center;
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .detail {
                        padding-top: 10px;

                        .rate {
                            margin-top: 10px;

                            & > div {
                                margin: 0 auto;
                                display: block;
                                width: 120px;
                            }
                        }

                        .name {
                            text-transform: uppercase;
                            font-weight: bold;
                            text-align: center;
                            padding: 10px;
                            padding-bottom: 5px;
                        }

                        .desc {
                            text-align: center;
                            font-size: 14px;
                            opacity: .5;
                        }

                        .price {
                            text-align: center;
                            font-weight: bold;
                            font-size: 22px;
                            padding: 10px;
                            color: #13ce66;
                        }
                    }

                    .buttons {
                        position: absolute;
                        left: 20px;
                        bottom: 5px;
                        right: 20px;

                        button {
                            background: white;
                            color: $text-color;
                            border: none;
                            text-transform: uppercase;
                            outline: none;
                            font-family: inherit;
                            font-weight: bold;
                            padding: 3px 7px;
                            font-size: 20px;
                            cursor: pointer;
                        }
                    }

                    &:hover {
                        box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065), 0px 10px 0px 0px #ed1d24;
                    }
                }
            }
        }
    }

    @media (max-width: 1400px) {
        .page-ecommerce-products {

            .list {
                .item {
                    width: 33.33%;
                }
            }
        }
    }


    @media (max-width: 1100px) {
        .page-ecommerce-products {

            .list {
                .item {
                    width: 50%;
                }
            }
        }
    }


    @media (max-width: 900px) {
        .page-ecommerce-products {

            .sidebar {
                width: 200px;
            }

        }
    }

    @media (max-width: 768px) {
        .page-ecommerce-products {

            .sidebar {
                width: 230px;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                margin: 0;
                z-index: 999;
                transform: translateX(-100%);
                transition: all .25s;
                background: white;

                .scroller {
                    padding: 15px;
                    padding-top: 20px;
                }

                .widget {
                    &.close-filter-box {
                        display: block;
                    }
                }

                &.open {
                    transform: translateX(0%);
                    box-shadow: 3px 0px 10px -3px rgba(0, 0, 0, 0.4);
                    border-top-left-radius: 4px;
                    border-top-right-radius: 4px;
                }
            }

            .toggle-filter-box {
                display: block;
            }

        }
    }

    @media (max-width: 480px) {
        .page-ecommerce-products {

            .list {
                .item {
                    width: 100%;
                }
            }
        }
    }

    .flip-list-move {
        transition: transform 1s;
    }
</style>
